import { Tooltip } from '@mui/material';
import { useCanViewEmails } from '../../../../helpers/useCanViewEmails';
import React, { useEffect, useRef, useState } from 'react';
import { SingleValue } from 'react-select';
import { useSnackbar } from 'material-ui-snackbar-provider';
import lodash from 'lodash';
import cs from 'classnames';

import { FILE_ACCESS_TYPE, FOLDER_TYPE, GROUP, GROUP_WITH_SUBGROUP, USER_NEW, VIDEOFEED } from '../../../../enums/TYPES';
import { SHARE_TYPE, GROUP_TYPE, SHARED_CONTENT_ENUM, VIDEOFEED_TYPE } from '../../../../enums/ENUMS';
import { ACCESS_TYPE, ACCESS_TYPE_ENUM, ACCESS_TYPE_KEYS } from '../../../../enums/ACCESS_ENUM';
import { removeSelectedFolder, switchShareModal } from '../../../../store/folders/foldersSlice';
import {
  AccessMapJson,
  AccessType,
  DownloadType,
  NewAccessType,
  RenotifyIdType,
  // додано "чергові" типи
  Action,
  ActionKind,
  DeleteAccessAction,
  PatchAccessAction,
  CreateAccessAction,
  PatchDownloadAction,
  CreateAccessBody,
} from '../../MyFolderPage/ShareFolderModal';
import { patchFolderAccess, patchAccessDownloadPermission, postArrayOfNewAccesses } from '../../../../api/foldersApi';
import { getAllWithoutQueryComposers, getVideofeedAccessess } from '../../../../api';
import { USER_SHARE_OPTIONS } from '../../MyFolderPage/ShareFolderModal/UserList';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import useOnClickOutside from '../../../../helpers/useOnClickOutside';
import BellIconFilled from '../../../../assets/icons/bell-button-filled.svg';
import { getGroupsThunk } from '../../../../store/groups/groupsSlice';
import ShareModalExcludedUserList from '../../ExcludedUsersList';
import { getExcludeList, getUsersByRolesArray } from '../../../../api/usersApi';
import { postRenotify } from '../../../../api/notificationsApi';
import { RENOTIFY_BODY } from '../../../../enums/NOTIFICATION';
import { ContainedButton, OutlinedButton } from '../../../modules/Buttons';
import { deleteAccess } from '../../../../api/accessesApi';
import useDebounce from '../../../../helpers/useDebounce';
import { RolesLowerCase } from '../../../../enums/ROLES';
import BellIcon from '../../../../assets/icons/share-notify-off.svg';
import ShareComposerModalGroupsList from './GroupList';
import SearchInput from '../../../modules/SearchInput';
import { getGroups } from '../../../../api/groupsApi';
import {
  getComposersThunk,
  removeSelectedComposer,
  selectShareComposer,
  switchShareModalComposer,
} from '../../../../store/composers/composersSlice';
import ShareComposerModalUserList from './UserList';
import RolePlate from '../../../modules/RolePlate';
import css from './ShareComposerModal.module.scss';
import { useHotkeys } from 'react-hotkeys-hook';
import AllUsersList from '../../AllUsersList';
import { getDefaultShareAllowDownloads } from '../../../../helpers';
import Modal from '../../../modules/Modal';
import { PATHS } from '../../../../enums';

type TShareComposerModal = {
  onUpdate?: React.Dispatch<React.SetStateAction<object>>;
};

const ShareComposerModal: React.FC<TShareComposerModal> = ({ onUpdate }) => {
  const canViewEmails = useCanViewEmails();
  const searchResultBarRef = useRef(null);
  const searchGroupResultBarRef = useRef(null);
  const contentWrapperRef = useRef<HTMLDivElement>(null);
  const searchExcludedUsersResultBarRef = useRef(null);
  const submitButtonRef = useRef<HTMLDivElement>(null);

  const dispatch = useAppDispatch();
  const notification = useSnackbar();

  const { showShareModal, shareFolder } = useAppSelector((state) => state.folderStore);
  const {
    showShareModalComposer,
    shareComposer,
    page: comPage,
    limit: comLimit,
    sort,
    sortOption,
  } = useAppSelector((state) => state.composersStore);

  const { currentUser, myOrganization } = useAppSelector((state) => state.user);
  const { groups: allGroups } = useAppSelector((state) => state.groupsStore);

  const [userAccessList, setUserAccessList] = useState<FILE_ACCESS_TYPE[]>([]);
  const [groupAccessList, setGroupAccessList] = useState<FILE_ACCESS_TYPE[]>([]);
  const [subGroupAccessList, setSubGroupAccessList] = useState<FILE_ACCESS_TYPE[]>([]);
  const [excludedUsersAccessList, setExcludedUsersAccessList] = useState<FILE_ACCESS_TYPE[]>([]);

  const [shareWithOrganization, setShareWithOrganization] = useState(false);
  const [orgDownloadPermission, setOrgDownloadPermission] = useState<boolean>(() => getDefaultShareAllowDownloads());

  const [loading, setLoading] = useState(false);
  const [idsToRenotify, setIdsToRenotify] = useState<RENOTIFY_BODY | null>(null);
  const [renotifyAll, setRenotifyAll] = useState(false);

  // ====== Черга дій (як у новій ShareFolderModal) ======
  const actionQ = useRef<Action[]>([]);
  const [plannedOps, setPlannedOps] = useState<Action[]>([]);
  const [hasPending, setHasPending] = useState(false);

  const [pendingDeleteIds, setPendingDeleteIds] = useState<string[]>([]);
  const queueDeletion = (...ids: string[]) => setPendingDeleteIds((prev) => [...prev, ...ids.filter((id) => !prev.includes(id))]);

  const syncPlanned = () => {
    setPlannedOps([...actionQ.current]);
    setHasPending(actionQ.current.length > 0);
  };

  const enqueue = (a: Action) => {
    actionQ.current.push(a);
    syncPlanned();
  };

  const enqueueDownload = (accessId: string, allowDownload: boolean) => {
    for (let i = actionQ.current.length - 1; i >= 0; i--) {
      const act = actionQ.current[i];
      if (act.kind === ActionKind.PATCH_DOWNLOAD && (act as PatchDownloadAction).accessId === accessId) {
        (act as PatchDownloadAction).allowDownload = allowDownload;
        syncPlanned();
        return;
      }
    }
    enqueue({ kind: ActionKind.PATCH_DOWNLOAD, when: Date.now(), accessId, allowDownload });
  };

  const cancelCreateFor = (predicate: (a: CreateAccessAction) => boolean) => {
    actionQ.current = actionQ.current.filter((x) => !(x.kind === ActionKind.CREATE_ACCESS && predicate(x as CreateAccessAction)));
    syncPlanned();
  };

  const drainQueue = async (redirectUrlToSend: string) => {
    const q = actionQ.current;
    let i = 0;
    while (i < q.length) {
      const a = q[i];

      if (a.kind === ActionKind.CREATE_ACCESS) {
        const batch: CreateAccessBody[] = [];
        while (i < q.length && q[i].kind === ActionKind.CREATE_ACCESS) {
          batch.push((q[i] as CreateAccessAction).body);
          i++;
        }
        await postArrayOfNewAccesses(
          batch.map((body) => ({
            ...body,
            notify: body.doNotNotify ? false : notify,
            contentUrl: redirectUrlToSend,
            messageTextForSharedContent,
            ...(typeof (body as any).excluded === 'boolean' ? { excluded: (body as any).excluded } : {}),
          })),
        );
        continue;
      }

      switch (a.kind) {
        case ActionKind.DELETE_ACCESS: {
          const { accessId } = a as DeleteAccessAction;
          await deleteAccess(accessId);
          break;
        }
        case ActionKind.PATCH_ACCESS: {
          const { accessId, access, doNotNotify, excluded } = a as PatchAccessAction;
          await patchFolderAccess({
            accessId,
            access: access as ACCESS_TYPE,
            notify: doNotNotify ? false : notify,
            contentUrl: redirectUrlToSend,
            messageTextForSharedContent,
            ...(typeof excluded === 'boolean' ? { excluded } : {}),
          });
          break;
        }
        case ActionKind.PATCH_DOWNLOAD: {
          const { accessId, allowDownload } = a as PatchDownloadAction;
          await patchAccessDownloadPermission(accessId, allowDownload);
          break;
        }
      }
      i++;
    }
  };

  // ====== Fetch composer ======
  const [thisComposer, setThisComposer] = useState<VIDEOFEED | null>(null);
  const fetchFolder = async () => {
    setLoading(true);
    try {
      const res = await getVideofeedAccessess(shareComposer?.id!);
      if (res.data) setThisComposer(res.data);
    } catch (error: any) {
      console.log(error);
      if (error?.response?.data?.message) notification.showMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (showShareModalComposer && shareComposer) fetchFolder();
  }, [showShareModalComposer, shareComposer]);

  useEffect(() => {
    dispatch(getGroupsThunk());
  }, []);

  const isExcludedAccess = (a: FILE_ACCESS_TYPE) => {
    const title = a?.access?.title as ACCESS_TYPE_ENUM | undefined;
    const excludedFlag = a?.excluded;
    return title === ACCESS_TYPE_ENUM.WITHOUT_ACCESS && (typeof excludedFlag === 'boolean' ? excludedFlag : true);
  };

  // ====== Re-notify ======
  const switchNotifyAll = () => setRenotifyAll(!renotifyAll);

  const pushAllNewEntitiesToRenotify = () => {
    const users = [...idsToRenotify!.userIds];
    const groups = [...idsToRenotify!.groupIds];
    if (newUsersAccess) {
      const arrayOfNewUsers = Object.entries(newUsersAccess);
      arrayOfNewUsers.forEach(([, v]) => v.user && users.push(v.user));
    }
    if (newGroupAccess) {
      const arrayOfNewGroups = Object.entries(newGroupAccess);
      arrayOfNewGroups.forEach(([, v]) => {
        if (v.group) groups.push(v.group);
      });
    }
    if (userAccessList.length) {
      userAccessList.forEach((access) => access.user && users.push(access.user.id));
    }
    if (groupAccessList.length) {
      groupAccessList.forEach((access) => {
        if (access?.group) {
          groups.push(access.group.id);
          access.group.subgroups.forEach((sub) => groups.push(sub.id));
        }
      });
    }
    // @ts-ignore
    setIdsToRenotify({ ...idsToRenotify, userIds: users, groupIds: groups });
  };

  const addEntityToRenotify = (id: string, type: RenotifyIdType, includeSubgroups?: GROUP) => {
    if (!idsToRenotify) return;
    if (type === RenotifyIdType.GROUP && includeSubgroups) {
      let groupIds = [...idsToRenotify.groupIds];
      if (groupIds.includes(id)) {
        groupIds = groupIds.filter((gid) => !includeSubgroups.subgroups.map((g) => g.id).includes(gid));
        groupIds = groupIds.filter((gid) => gid !== id);
      } else {
        groupIds = [...groupIds, id, ...includeSubgroups.subgroups.map((g) => g.id)];
      }
      setIdsToRenotify({ ...idsToRenotify, groupIds });
    } else if (type === RenotifyIdType.GROUP) {
      const groupIds = [...idsToRenotify.groupIds];
      const idx = groupIds.indexOf(id);
      if (idx >= 0) groupIds.splice(idx, 1);
      else groupIds.push(id);
      setIdsToRenotify({ ...idsToRenotify, groupIds });
    } else if (type === RenotifyIdType.USER) {
      const userIds = [...idsToRenotify.userIds];
      const idx = userIds.indexOf(id);
      if (idx >= 0) userIds.splice(idx, 1);
      else userIds.push(id);
      setIdsToRenotify({ ...idsToRenotify, userIds });
    }
  };

  useEffect(() => {
    if (renotifyAll && idsToRenotify) {
      pushAllNewEntitiesToRenotify();
    } else if (thisComposer) {
      determineAndSetVideofeedType();
    }
  }, [renotifyAll]);

  const determineAndSetVideofeedType = () => {
    let feedType: SHARED_CONTENT_ENUM;
    switch (thisComposer!.type) {
      case VIDEOFEED_TYPE.TIMELINE:
        feedType = SHARED_CONTENT_ENUM.SHARED_TIMELINE;
        break;
      case VIDEOFEED_TYPE.MY_COMPOSER:
      case VIDEOFEED_TYPE.ONLINE_COMPOSER:
        feedType = SHARED_CONTENT_ENUM.SHARED_ONLINE_COMPOSER;
        break;
      case VIDEOFEED_TYPE.REFLEX_COMPOSER:
      case VIDEOFEED_TYPE.COMPOSER:
      default:
        feedType = SHARED_CONTENT_ENUM.SHARED_COMPOSER;
        break;
    }
    setIdsToRenotify({
      userIds: [],
      groupIds: [],
      contentId: thisComposer!.id,
      contentType: feedType,
    });
  };

  useEffect(() => {
    if (thisComposer) determineAndSetVideofeedType();

    const orgAccess = thisComposer?.access.find((a) => a.type === 'organization' && a?.organization?.id == thisComposer.organization_id);
    if (orgAccess) {
      setShareWithOrganization(true);
      setOrgDownloadPermission(!!orgAccess.allow_downloads);
    }
  }, [thisComposer]);

  // ====== Org effective access helpers ======
  const [downloadPermissions, setDownloadPermissions] = useState<DownloadType>({});
  const [newOrganizationAccess, setNewOrganizationAccess] = useState<NewAccessType>();

  const normalizeAccessTitle = (acc: any): ACCESS_TYPE_ENUM => {
    if (!acc) return ACCESS_TYPE_ENUM.WITHOUT_ACCESS;
    if (typeof acc === 'string') return acc as ACCESS_TYPE_ENUM;
    if (typeof acc === 'object' && 'title' in acc) return (acc.title as ACCESS_TYPE_ENUM) ?? ACCESS_TYPE_ENUM.WITHOUT_ACCESS;
    return ACCESS_TYPE_ENUM.WITHOUT_ACCESS;
  };

  const isDeletedAccessId = (id?: string) =>
    !!id && actionQ.current.some((a) => a.kind === ActionKind.DELETE_ACCESS && (a as DeleteAccessAction).accessId === id);

  const updateCreateDraft = (type: 'group' | 'user' | 'organization', key: string, patch: Partial<CreateAccessBody>) => {
    for (let i = actionQ.current.length - 1; i >= 0; i--) {
      const act = actionQ.current[i];
      if (act.kind !== ActionKind.CREATE_ACCESS) continue;
      const c = act as CreateAccessAction;
      const matches =
        (type === 'group' && c.body.type === 'group' && c.body.group === key) ||
        (type === 'user' && c.body.type === 'user' && c.body.user === key) ||
        (type === 'organization' && c.body.type === 'organization' && c.body.organization === key);
      if (matches) {
        c.body = { ...c.body, ...patch };
        syncPlanned();
        return true;
      }
    }
    return false;
  };

  const getEffectiveOrganizationAccess = () => {
    if (!thisComposer?.organization_id) return { exists: false as const };
    const orgId = String(thisComposer.organization_id);

    const draft = newOrganizationAccess?.[orgId];
    if (draft) {
      return {
        exists: true as const,
        access: (draft.access as ACCESS_TYPE_ENUM) ?? ACCESS_TYPE_ENUM.COMMENT_AND_CREATE,
        allow: typeof draft.allowDownloads === 'boolean' ? draft.allowDownloads : getDefaultShareAllowDownloads(),
        accessId: undefined as string | undefined,
      };
    }

    const existing = thisComposer.access.find((a) => a.type === 'organization' && String(a.organization?.id) === orgId);
    if (existing && !isDeletedAccessId(existing.id)) {
      let acc: ACCESS_TYPE_ENUM = existing.access?.title as ACCESS_TYPE_ENUM;
      for (let i = actionQ.current.length - 1; i >= 0; i--) {
        const act = actionQ.current[i];
        if (act.kind === ActionKind.PATCH_ACCESS && (act as PatchAccessAction).accessId === existing.id) {
          acc = (act as PatchAccessAction).access as ACCESS_TYPE_ENUM;
          break;
        }
      }

      let allow: boolean | undefined = downloadPermissions[existing.id]?.allowDownload;
      if (typeof allow !== 'boolean') {
        for (let i = actionQ.current.length - 1; i >= 0; i--) {
          const act = actionQ.current[i];
          if (act.kind === ActionKind.PATCH_DOWNLOAD && (act as PatchDownloadAction).accessId === existing.id) {
            allow = (act as PatchDownloadAction).allowDownload;
            break;
          }
        }
      }
      if (typeof allow !== 'boolean') allow = !!existing.allow_downloads;

      return { exists: true as const, access: acc, allow: allow!, accessId: existing.id };
    }

    return { exists: false as const };
  };

  const onOrgDownloadPermissionChange = () => {
    const next = !orgDownloadPermission;
    setOrgDownloadPermission(next);

    const orgId = String(thisComposer!.organization_id);
    const existingOrg = thisComposer?.access.find((a) => a.type === 'organization' && String(a.organization?.id) === orgId);
    if (existingOrg && !isDeletedAccessId(existingOrg.id)) {
      setDownloadPermissions((prev) => ({ ...prev, [existingOrg.id]: { allowDownload: next } }));
      enqueueDownload(existingOrg.id, next);
      return;
    }

    setNewOrganizationAccess((prev) => {
      const desiredAccess = prev?.[orgId]?.access ?? ACCESS_TYPE_ENUM.COMMENT_AND_CREATE;
      const nextMap: NewAccessType = {
        ...(prev ?? {}),
        [orgId]: {
          targetType: 'online_composer',
          targetId: thisComposer!.id,
          organization: orgId,
          type: 'organization',
          access: desiredAccess,
          allowDownloads: next,
        },
      };
      return nextMap;
    });

    const updated = updateCreateDraft('organization', orgId, { allowDownloads: next });
    if (!updated) {
      const accessForCreate = newOrganizationAccess?.[orgId]?.access ?? ACCESS_TYPE_ENUM.COMMENT_AND_CREATE;
      enqueue({
        kind: ActionKind.CREATE_ACCESS,
        when: Date.now(),
        body: {
          targetType: 'online_composer',
          targetId: thisComposer!.id,
          organization: orgId,
          type: 'organization',
          access: accessForCreate,
          allowDownloads: next,
        },
      });
    }
    syncPlanned();
  };

  const onNewOrganizationAccessChange = (access?: SingleValue<{ value: string; label: ACCESS_TYPE }>, downloadPermission?: boolean) => {
    let obj = {} as any;
    const orgAccess = thisComposer?.access.find((a) => a.type === 'organization');

    if (orgAccess && pendingDeleteIds.includes(orgAccess.id)) {
      setPendingDeleteIds(pendingDeleteIds.filter((id) => id !== orgAccess.id));
      return;
    }

    if (orgAccess) {
      const desiredAccess = access?.value ?? orgAccess.access.title;
      const desiredAllow = typeof downloadPermission === 'boolean' ? downloadPermission : orgDownloadPermission;
      if (desiredAccess !== orgAccess.access.title) {
        enqueue({ kind: ActionKind.PATCH_ACCESS, when: Date.now(), accessId: orgAccess.id, access: desiredAccess });
      }
      if (desiredAllow !== orgAccess.allow_downloads) {
        enqueueDownload(orgAccess.id, desiredAllow);
      }
      setNewOrganizationAccess(undefined);
      return;
    }

    const orgId = String(thisComposer!.organization_id);
    const desiredAllow = typeof downloadPermission === 'boolean' ? downloadPermission : orgDownloadPermission;
    const desiredAccess = access?.value || newOrganizationAccess?.[orgId]?.access || ACCESS_TYPE_ENUM.COMMENT_AND_CREATE;

    obj = {
      ...newOrganizationAccess,
      [orgId]: {
        targetType: 'online_composer',
        targetId: thisComposer!.id,
        organization: orgId,
        type: 'organization',
        allowDownloads: desiredAllow,
        access: desiredAccess,
      },
    };

    const updated = updateCreateDraft('organization', orgId, { access: desiredAccess, allowDownloads: desiredAllow });
    if (!updated) {
      enqueue({
        kind: ActionKind.CREATE_ACCESS,
        when: Date.now(),
        body: obj[orgId],
      });
    }
    setNewOrganizationAccess(obj);
  };

  const switchShareWithEveryone = () => {
    if (!shareWithOrganization) {
      onNewOrganizationAccessChange(USER_SHARE_OPTIONS[2], true);
    } else {
      handleDeleteOrganization();
    }
    setShareWithOrganization(!shareWithOrganization);
  };

  // ====== Roles UI helper ======
  const rolesUpdater = (accesses: FILE_ACCESS_TYPE[]) =>
    accesses.map((obj) => {
      const modified = lodash.cloneDeep(obj);
      if (modified.user && modified.user.organization_users) {
        const foundObject = modified.user.organization_users.find((ob: any) => ob.organization.id === myOrganization?.id);
        if (foundObject) modified.user.role = foundObject.role;
      }
      return modified;
    });

  const [accessMapJson, setAccessMapJson] = useState<AccessMapJson[]>([]);

  // ====== Parse existing accesses ======
  const accessArrayParser = (data: FOLDER_TYPE | VIDEOFEED) => {
    const userAccesses = data?.access.filter(
      (item) => item?.type === SHARE_TYPE.USER && !(item.access.title === ACCESS_TYPE_ENUM.WITHOUT_ACCESS && item.excluded),
    );
    const groups = data?.access.filter(
      (item) => item?.type === SHARE_TYPE.GROUP && !(item.access.title === ACCESS_TYPE_ENUM.WITHOUT_ACCESS && item.excluded),
    );

    const excludedGroups = data?.access.filter((item) => item?.type === SHARE_TYPE.GROUP && isExcludedAccess(item));
    const excludedUsersAccesses = data?.access.filter((item) => item?.type === SHARE_TYPE.USER && isExcludedAccess(item));

    const mainGroups = groups?.filter((item) => item?.group?.type === GROUP_TYPE.GROUP) || [];
    const subGroups = groups?.filter((item) => item?.group?.type === GROUP_TYPE.SUBGROUP) || [];

    if (subGroups) {
      let refetch = false;
      subGroups.forEach(async (subG) => {
        if (subG.group?.parent_group?.id && !mainGroups?.find((gr) => gr.group.id == subG.group?.parent_group?.id)) {
          await deleteAccess(subG.id);
          refetch = true;
        }
      });

      if (refetch) {
        if (thisComposer) {
          dispatch(getComposersThunk({ page: comPage, limit: comLimit, sort, sortOption }));
        }
        if (onUpdate) onUpdate({});
      }
    }

    const groupsWithAccessess: AccessMapJson[] = [];
    mainGroups.forEach((g) => {
      const parentGroup = allGroups?.find((mainG) => mainG.id === g.group!.id);
      const obj: AccessMapJson = {
        id: g.group!.id,
        access: normalizeAccessTitle(g.access),
        subGroups: parentGroup?.subgroups.map((sub) => ({ id: sub.id, access: '' })) || [],
      };
      g.group!.subgroups.forEach((sub) => {
        const subGroupAccess = subGroups.find((subAcc) => subAcc.group!.id === sub.id);
        const indexOfSubgroup = obj.subGroups?.findIndex((s) => s.id === sub.id);
        if (indexOfSubgroup >= 0) {
          obj.subGroups[indexOfSubgroup] = {
            ...obj.subGroups[indexOfSubgroup],
            access: normalizeAccessTitle(subGroupAccess?.access),
          };
        }
      });
      groupsWithAccessess.push(obj);
    });
    setAccessMapJson(groupsWithAccessess);
    setSubGroupAccessList(subGroups);

    const userAccessesModified = rolesUpdater(userAccesses);
    const excludedUsersAccessesModified = rolesUpdater(excludedUsersAccesses);

    setUserAccessList(userAccessesModified.filter((a) => a?.user?.id !== currentUser?.id));
    setExcludedUsersAccessList([...excludedUsersAccessesModified.filter((a) => a?.user?.id !== currentUser?.id), ...excludedGroups]);
    setGroupAccessList([...mainGroups]);
  };

  useEffect(() => {
    if (shareFolder) accessArrayParser(shareFolder);
    else if (thisComposer) accessArrayParser(thisComposer);
  }, [shareFolder, thisComposer, allGroups]);

  // ====== Users search ======
  const [searchedUsers, setSearchedUsers] = useState<USER_NEW[]>([]);
  const [isUserSearchLoading, setIsUserSearchLoading] = useState(false);
  const [isUserSearchEmpty, setIsUserSearchEmpty] = useState(false);
  const [searchText, setSearchText] = useState('');
  const debounce = useDebounce<string>(searchText, 500);
  const onUserSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchText(value);
    setIsUserSearchLoading(value.trim().length > 0);
    setIsUserSearchEmpty(false);
  };
  const fetchSearch = async () => {
    setIsUserSearchLoading(true);
    try {
      const ignoreUsers = [...userAccessList.map((u) => u.user.id), ...newUsers.map((u) => u.id), currentUser?.id || ''];
      const res = await getUsersByRolesArray(
        [RolesLowerCase.ORGANIZATION_ADMIN, RolesLowerCase.ANALYST, RolesLowerCase.VIEWER],
        searchText,
        ignoreUsers,
      );
      setSearchedUsers(res.documents);
      setIsUserSearchEmpty((res.documents || []).length === 0);
    } catch (err) {
      console.log(err);
    } finally {
      setIsUserSearchLoading(false);
    }
  };
  useEffect(() => {
    if (shareFolder || thisComposer) {
      if (!searchText) {
        setSearchedUsers([]);
        setIsUserSearchLoading(false);
      } else fetchSearch();
    }
  }, [debounce, shareFolder, thisComposer]);

  // ====== Group search ======
  const [searchedGroups, setSearchedGroups] = useState<GROUP[]>([]);
  const [isGroupSearchLoading, setIsGroupSearchLoading] = useState(false);
  const [isGroupSearchEmpty, setIsGroupSearchEmpty] = useState(false);
  const [searchGroupText, setSearchGroupText] = useState('');
  const debounceGroup = useDebounce<string>(searchGroupText, 500);
  const onGroupSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchGroupText(value);
    setIsGroupSearchLoading(value.trim().length > 0);
    setIsGroupSearchEmpty(false);
  };
  const fetchSearchGroup = async () => {
    setIsGroupSearchLoading(true);
    try {
      const ignoreGroups = [
        ...groupAccessList.map((g) => g.group.id),
        ...newGroups.map((g: GROUP) => g.id),
        ...subGroupAccessList.map((s) => s.group.id),
      ];
      const res = await getGroups({ search: searchGroupText });
      const resultArr = res.documents.filter((org: GROUP_WITH_SUBGROUP) => !ignoreGroups.includes(org.id));
      setSearchedGroups(resultArr);
      setIsGroupSearchEmpty(resultArr.length === 0);
    } catch (err) {
      console.log(err);
    } finally {
      setIsGroupSearchLoading(false);
    }
  };
  useEffect(() => {
    if (!searchGroupText && (shareFolder || thisComposer)) {
      setSearchedGroups([]);
      setIsGroupSearchLoading(false);
      setIsGroupSearchEmpty(false);
    } else if (searchGroupText && (shareFolder || thisComposer)) fetchSearchGroup();
  }, [debounceGroup, shareFolder, thisComposer]);

  // ====== Exclude search ======
  const [searchedExclusions, setSearchedExclusions] = useState<(USER_NEW | GROUP)[]>([]);
  const [isExclusionsSearchLoading, setIsExclusionsSearchLoading] = useState(false);
  const [isExclusionsSearchEmpty, setIsExclusionsSearchEmpty] = useState(false);
  const [searchExclusionsText, setSearchExclusionsText] = useState('');
  const debounceExclusions = useDebounce<string>(searchExclusionsText, 500);
  const onExclusionsSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchExclusionsText(value);
    setIsExclusionsSearchLoading(value.trim().length > 0);
    setIsExclusionsSearchEmpty(false);
  };
  const fetchExclusions = async () => {
    setIsExclusionsSearchLoading(true);
    try {
      const ignoreUsers = [
        ...excludedUsersAccessList.filter((e) => 'user_name' in e).map((a: any) => a.user?.id),
        ...(newExcludedUsers.filter((e) => 'user_name' in e) as USER_NEW[]).map((u) => u.user.id),
        currentUser?.id || '',
      ];
      const ignoreGroups = [
        ...excludedUsersAccessList.filter((e) => 'title' in e).map((a: any) => a.user?.id),
        ...(newExcludedUsers.filter((e) => 'title' in e) as GROUP[]).map((g) => g.id),
      ];
      const res = await getExcludeList(searchExclusionsText, ignoreUsers, ignoreGroups);
      setSearchedExclusions(res);
      setIsExclusionsSearchEmpty((res || []).length === 0);
    } catch (err) {
      console.log(err);
    } finally {
      setIsExclusionsSearchLoading(false);
    }
  };
  useEffect(() => {
    if (!searchExclusionsText && thisComposer && allGroups?.length) {
      setSearchedExclusions([]);
      setIsExclusionsSearchLoading(false);
      setIsExclusionsSearchEmpty(false);
    } else if (searchExclusionsText && thisComposer) fetchExclusions();
  }, [debounceExclusions, thisComposer, allGroups]);

  // ====== Group access change (existing) ======
  const [groupAccess, setGroupAccess] = useState<AccessType>();
  const onGroupAccessChange = (
    accessId: string,
    access: SingleValue<{ value: string; label: ACCESS_TYPE }>,
    groupId: string,
    groupType: GROUP_TYPE,
    accessObject?: FILE_ACCESS_TYPE,
  ) => {
    const isNoAccess = access?.value === ACCESS_TYPE_ENUM.NO_ACCESS || access?.value === ACCESS_TYPE_ENUM.WITHOUT_ACCESS;
    const accessMapJsonCopied = lodash.cloneDeep(accessMapJson);
    const itsGroup = accessMapJsonCopied.find((g) => g.id === groupId);
    const itsSubgroup = accessMapJsonCopied.find((g) => g.subGroups.find((sub) => sub.id === groupId));
    if (itsGroup) {
      const idx = accessMapJsonCopied.findIndex((g) => g.id === itsGroup.id);
      accessMapJsonCopied[idx] = { ...accessMapJsonCopied[idx], access: access?.value! };
      if (access?.value !== ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS) {
        accessMapJsonCopied[idx].subGroups.forEach((_, i) => {
          accessMapJsonCopied[idx].subGroups[i] = { ...accessMapJsonCopied[idx].subGroups[i], access: access?.value! };
        });
      }
    } else if (itsSubgroup) {
      const idx = accessMapJsonCopied.findIndex((g) => g.id === itsSubgroup.id);
      const sIdx = accessMapJsonCopied[idx].subGroups.findIndex((sub) => sub.id === groupId);
      accessMapJsonCopied[idx].subGroups[sIdx] = { id: groupId, access: access?.value! };
    }
    setAccessMapJson(accessMapJsonCopied);

    enqueue({
      kind: ActionKind.PATCH_ACCESS,
      when: Date.now(),
      accessId,
      access: access!.value,
      ...(access?.value === ACCESS_TYPE_ENUM.NO_ACCESS ? { excluded: false } : {}),
      doNotNotify: access?.value === ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS || undefined,
    });

    if (isNoAccess) {
      setDownloadPermissions((prev) => ({ ...prev, [accessId]: { allowDownload: false } }));
      enqueueDownload(accessId, false);
    }

    if (
      access?.value !== ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS &&
      groupType === GROUP_TYPE.GROUP &&
      accessObject &&
      accessObject.group.subgroups
    ) {
      accessObject.group.subgroups.forEach((sub) => {
        const subgroupAccessObject = subGroupAccessList.find((subAcc) => subAcc.group.id === sub.id);
        if (subgroupAccessObject) {
          enqueue({
            kind: ActionKind.PATCH_ACCESS,
            when: Date.now(),
            ...(access?.value === ACCESS_TYPE_ENUM.NO_ACCESS ? { excluded: false } : {}),
            accessId: subgroupAccessObject.id,
            access: access!.value,
          });

          if (isNoAccess) {
            setDownloadPermissions((prev) => ({ ...prev, [subgroupAccessObject.id]: { allowDownload: false } }));
            enqueueDownload(subgroupAccessObject.id, false);
          }
        } else {
          const excluded = excludedUsersAccessList.some(
            (ex) => ex.type === 'group' && ex.group?.id === sub.id && ex.access?.title === ACCESS_TYPE_ENUM.WITHOUT_ACCESS,
          );
          if (!excluded) {
            enqueue({
              kind: ActionKind.CREATE_ACCESS,
              when: Date.now(),
              body: {
                targetType: shareFolder ? 'folder' : 'online_composer',
                targetId: shareFolder?.id ?? thisComposer!.id,
                group: sub.id,
                allowDownloads: isNoAccess ? false : getDefaultShareAllowDownloads(),
                type: 'group',
                access: access!.value,
                ...(isNoAccess ? { excluded: false } : {}),
              },
            });
          }
        }
      });
    }

    const obj = {
      ...groupAccess,
      [accessId]: { access: access!.value, ...(access?.value === ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS ? { doNotNotify: true } : {}) },
    };
    setGroupAccess((prev) => ({ ...prev, ...obj }));
  };

  // ====== New groups ======
  const [newGroups, setNewGroups] = useState<GROUP[]>([]);
  const [newGroupAccess, setNewGroupAccess] = useState<NewAccessType | undefined>();

  const onNewGroupAccessChange = (
    groupId: string,
    access: SingleValue<{ value: string; label: ACCESS_TYPE }>,
    groupType: GROUP_TYPE,
    groupObj?: GROUP_WITH_SUBGROUP,
  ) => {
    const isNoAccess = access?.value === ACCESS_TYPE_ENUM.NO_ACCESS;
    const allow = isNoAccess ? false : getDefaultShareAllowDownloads();
    const parent = allGroups.find((g) => g.id === groupId) || newGroups.find((g) => g.id === groupId);
    const subIds = new Set((parent?.subgroups ?? []).map((s) => s.id));
    actionQ.current = actionQ.current.filter((a) => {
      if (a.kind !== ActionKind.CREATE_ACCESS) return true;
      const c = a as CreateAccessAction;
      if (c.body.type !== 'group') return true;
      const gid = c.body.group!;
      return gid !== groupId && !subIds.has(gid);
    });
    syncPlanned();

    const accessMapJsonCopied = lodash.cloneDeep(accessMapJson);
    const itsGroup = accessMapJsonCopied.find((g) => g.id === groupId);
    const itsSubgroup = accessMapJsonCopied.find((g) => g.subGroups.find((sub) => sub.id === groupId));
    if (itsGroup) {
      const idx = accessMapJsonCopied.findIndex((g) => g.id === itsGroup.id);
      accessMapJsonCopied[idx] = { ...accessMapJsonCopied[idx], access: access?.value! };
      if (access?.value !== ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS) {
        accessMapJsonCopied[idx].subGroups.forEach((_, i) => {
          accessMapJsonCopied[idx].subGroups[i] = { ...accessMapJsonCopied[idx].subGroups[i], access: access?.value! };
        });
      }
    } else if (itsSubgroup) {
      const idx = accessMapJsonCopied.findIndex((g) => g.id === itsSubgroup.id);
      const sIdx = accessMapJsonCopied[idx].subGroups.findIndex((sub) => sub.id === groupId);
      accessMapJsonCopied[idx].subGroups[sIdx] = { id: groupId, access: access?.value! };
    } else if (groupType === GROUP_TYPE.GROUP) {
      const already = accessMapJsonCopied.find((g) => g.id === groupId);
      const parentGroup = allGroups.find((g) => g.id === groupId);
      if (already) {
        const idx = accessMapJsonCopied.findIndex((g) => g.id === already.id);
        accessMapJsonCopied[idx] = { ...accessMapJsonCopied[idx], access: access?.value! };
        if (access?.value !== ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS) {
          accessMapJsonCopied[idx].subGroups.forEach((_, i) => {
            accessMapJsonCopied[idx].subGroups[i] = { ...accessMapJsonCopied[idx].subGroups[i], access: access?.value! };
          });
        }
      } else if (parentGroup) {
        accessMapJsonCopied.push({
          id: groupId,
          access: access?.value!,
          subGroups: parentGroup.subgroups.map((s) => ({ id: s.id, access: access?.value! })),
        });
      }
    }
    setAccessMapJson(accessMapJsonCopied);

    const patched = updateCreateDraft('group', String(groupId), {
      access: access!.value,
      allowDownloads: allow,
      ...(isNoAccess ? { excluded: false } : {}),
      ...(access?.value === ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS ? { doNotNotify: true } : {}),
    });

    if (!patched) {
      enqueue({
        kind: ActionKind.CREATE_ACCESS,
        when: Date.now(),
        body: {
          targetType: shareFolder ? 'folder' : 'online_composer',
          targetId: shareFolder?.id ?? thisComposer!.id,
          group: groupId,
          allowDownloads: allow,
          type: 'group',
          access: access!.value,
          ...(isNoAccess ? { excluded: false } : {}),
          ...(access?.value === ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS ? { doNotNotify: true } : {}),
        },
      });
    }

    if (access?.value !== ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS && groupType === GROUP_TYPE.GROUP && groupObj) {
      groupObj.subgroups.forEach((sub) => {
        enqueue({
          kind: ActionKind.CREATE_ACCESS,
          when: Date.now(),
          body: {
            targetType: shareFolder ? 'folder' : 'online_composer',
            targetId: shareFolder?.id ?? thisComposer!.id,
            group: sub.id,
            allowDownloads: allow,
            type: 'group',
            access: access!.value,
            ...(isNoAccess ? { excluded: false } : {}),
          },
        });
      });
    }

    setSearchedGroups([]);
    const obj = {
      ...newGroupAccess,
      [groupId]: {
        targetType: shareFolder ? 'folder' : 'online_composer',
        targetId: shareFolder?.id ?? thisComposer?.id,
        group: groupId,
        allowDownloads: allow,
        type: 'group',
        access: access!.value,
        ...(isNoAccess ? { excluded: false } : {}),
      },
    } as NewAccessType;
    if (access?.value === ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS) {
      (obj as any)[groupId].doNotNotify = true;
    }
    if (access?.value !== ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS && groupType === GROUP_TYPE.GROUP && groupObj) {
      groupObj.subgroups.forEach((sub) => {
        (obj as any)[sub.id] = {
          targetType: shareFolder ? 'folder' : 'online_composer',
          targetId: shareFolder?.id ?? thisComposer?.id,
          group: sub.id,
          allowDownloads: allow,
          type: 'group',
          access: access!.value,
          ...(isNoAccess ? { excluded: false } : {}),
        };
      });
    }
    setNewGroupAccess((prev) => ({ ...prev, ...obj }));
  };

  // ====== Users access (existing) ======
  const [usersAccess, setUsersAccess] = useState<AccessType>();
  const onUserAccessChange = (accessId: string, access: SingleValue<{ value: string; label: ACCESS_TYPE }>) => {
    enqueue({
      kind: ActionKind.PATCH_ACCESS,
      when: Date.now(),
      accessId,
      access: access!.value,
      ...(access?.value === ACCESS_TYPE_ENUM.NO_ACCESS ? { excluded: false } : {}),
    });
    const obj = { ...usersAccess, [accessId]: { access: access!.value } };
    setUsersAccess(obj);
  };

  // ====== Download toggles ======
  const onDownloadPermissionChange = (accessObject: any, accessId: string, allowDownload: boolean) => {
    if (!accessId) {
      // draft (new group)
      const draftId = accessObject?.group?.id || accessObject?.id || undefined;
      if (draftId) {
        if (newGroupAccess?.[draftId]) {
          const next = { ...newGroupAccess };
          next[draftId].allowDownloads = allowDownload;
          setNewGroupAccess(next);
          updateCreateDraft('group', String(draftId), { allowDownloads: allowDownload });
        }
      }
      return;
    }

    const selectedGroupAccess = groupAccessList.find((a) => a.id === accessId);
    const downloadPermissionsCopy: DownloadType = { ...downloadPermissions };

    if (selectedGroupAccess) {
      const subgroupIds = selectedGroupAccess.group?.subgroups.map((s) => s.id) || [];
      const existingSubAccesses = subGroupAccessList.filter((a) => subgroupIds.includes(a.group!.id)).map((a) => a.id);

      existingSubAccesses.forEach((subAccessId) => {
        downloadPermissionsCopy[subAccessId] = { allowDownload };
        enqueueDownload(subAccessId, allowDownload);
      });

      if (newGroupAccess) {
        const next = { ...newGroupAccess };
        subgroupIds.forEach((sgId) => {
          if (next[sgId]) {
            next[sgId].allowDownloads = allowDownload;
            updateCreateDraft('group', String(sgId), { allowDownloads: allowDownload });
          }
        });
        setNewGroupAccess(next);
      }
    }

    downloadPermissionsCopy[accessId] = { allowDownload };
    setDownloadPermissions((prev) => ({ ...prev, ...downloadPermissionsCopy }));
    enqueueDownload(accessId, allowDownload);
  };

  // ====== New users ======
  const [newUsers, setNewUsers] = useState<USER_NEW[]>([]);
  const [newUsersAccess, setNewUsersAccess] = useState<NewAccessType | undefined>();

  const onNewUserAccessChange = (userId: string, access: SingleValue<{ value: string; label: ACCESS_TYPE }>) => {
    setSearchedUsers([]);

    setNewUsersAccess((prev) => {
      const baseDraft = prev?.[userId] ?? {
        targetType: 'online_composer',
        targetId: thisComposer?.id,
        user: userId,
        type: 'user',
        allowDownloads: getDefaultShareAllowDownloads(
          newUsers.find((item) => item.user.id === userId)?.role?.title,
        ),
      };

      const withExcluded = access?.value === ACCESS_TYPE_ENUM.NO_ACCESS ? { excluded: false } : {};
      const nextForUser = { ...baseDraft, access: access!.value, ...withExcluded };
      const next = { ...(prev ?? {}), [userId]: nextForUser };

      const updated = updateCreateDraft('user', userId, {
        access: access!.value,
        allowDownloads: nextForUser.allowDownloads,
        ...withExcluded,
      });

      if (!updated) {
        enqueue({
          kind: ActionKind.CREATE_ACCESS,
          when: Date.now(),
          body: nextForUser as any,
        });
      }

      syncPlanned();
      return next;
    });
  };

  const onNewUserDownloadPermissionChange = (userId: string, allowDownload: boolean) => {
    setSearchedUsers([]);
    setNewUsersAccess((prev) => {
      if (!prev?.[userId]) return prev;
      const next = { ...prev, [userId]: { ...prev[userId], allowDownloads: allowDownload } };
      const updated = updateCreateDraft('user', userId, { allowDownloads: allowDownload });

      if (!updated) {
        enqueue({
          kind: ActionKind.CREATE_ACCESS,
          when: Date.now(),
          body: next[userId] as any,
        });
      }
      syncPlanned();
      return next;
    });
  };

  // ====== New group download toggle ======
  const onNewGroupDownloadPermissionChange = (groupId: string, allowDownload: boolean) => {
    setSearchedGroups([]);

    const lookupAccessFor = (id: string): ACCESS_TYPE_ENUM => {
      const asGroup = accessMapJson.find((g) => g.id === id);
      if (asGroup) return (asGroup.access as ACCESS_TYPE_ENUM) || ACCESS_TYPE_ENUM.COMMENT_AND_CREATE;
      const parent = accessMapJson.find((g) => g.subGroups?.some((s) => s.id === id));
      if (parent) {
        const sg = parent.subGroups.find((s) => s.id === id);
        return (sg?.access as ACCESS_TYPE_ENUM) || (parent.access as ACCESS_TYPE_ENUM) || ACCESS_TYPE_ENUM.COMMENT_AND_CREATE;
      }
      return ACCESS_TYPE_ENUM.COMMENT_AND_CREATE;
    };

    setNewGroupAccess((prev) => {
      const next = { ...(prev ?? {}) };

      const currentAcc = lookupAccessFor(groupId);
      const withExcluded = currentAcc === ACCESS_TYPE_ENUM.NO_ACCESS ? { excluded: false } : {};

      if (!next[groupId]) {
        next[groupId] = {
          targetType: shareFolder ? 'folder' : 'online_composer',
          targetId: shareFolder?.id ?? thisComposer!.id,
          group: groupId,
          allowDownloads: allowDownload,
          type: 'group',
          access: currentAcc,
          ...withExcluded,
        };

        const updated = updateCreateDraft('group', String(groupId), {
          allowDownloads: allowDownload,
          access: next[groupId].access,
          ...withExcluded,
        });
        if (!updated) {
          enqueue({
            kind: ActionKind.CREATE_ACCESS,
            when: Date.now(),
            body: next[groupId] as any,
          });
        }
      } else {
        next[groupId].allowDownloads = allowDownload;
        updateCreateDraft('group', String(groupId), { allowDownloads: allowDownload });
      }

      const selectedGroup = newGroups.find((g) => g.id === groupId);
      if (selectedGroup?.subgroups?.length) {
        selectedGroup.subgroups.forEach(({ id }) => {
          const accForSub = lookupAccessFor(id);
          const exclForSub = accForSub === ACCESS_TYPE_ENUM.NO_ACCESS ? { excluded: false } : {};
          if (!next[id]) {
            next[id] = {
              targetType: shareFolder ? 'folder' : 'online_composer',
              targetId: shareFolder?.id ?? thisComposer!.id,
              group: id,
              allowDownloads: allowDownload,
              type: 'group',
              access: accForSub || next[groupId].access,
              ...exclForSub,
            };
            const upd = updateCreateDraft('group', String(id), { allowDownloads: allowDownload, access: next[id].access, ...exclForSub });
            if (!upd) {
              enqueue({
                kind: ActionKind.CREATE_ACCESS,
                when: Date.now(),
                body: next[id] as any,
              });
            }
          } else {
            next[id].allowDownloads = allowDownload;
            updateCreateDraft('group', String(id), { allowDownloads: allowDownload });
          }
        });
      }

      return next;
    });
  };

  const getParentCurrentAccessAndAllow = (parentGroupId: string) => {
    const parent = groupAccessList.find((a) => a.group.id === parentGroupId);
    const mapEntry = accessMapJson.find((g) => g.id === parentGroupId);

    if (parent) {
      const patched = groupAccess?.[parent.id]?.access;
      const mapped = mapEntry?.access;
      const accessTitle = patched ?? mapped ?? parent.access.title;
      const allow = (downloadPermissions[parent.id]?.allowDownload ?? parent.allow_downloads ?? true) as boolean;
      return { accessTitle, allow, mode: 'existing' as const, accessId: parent.id };
    }

    const isNewParent = newGroups.find((g) => g.id === parentGroupId);
    if (isNewParent) {
      const ng = newGroupAccess?.[parentGroupId];
      const mapped = mapEntry?.access;
      const accessTitle = ng?.access ?? mapped ?? ACCESS_TYPE_ENUM.COMMENT_AND_CREATE;
      const allow = (ng?.allowDownloads ?? getDefaultShareAllowDownloads()) as boolean;
      return { accessTitle, allow, mode: 'new' as const, accessId: undefined };
    }

    return { accessTitle: null, allow: null, mode: 'none' as const, accessId: undefined };
  };

  const restoreSubgroupAfterExclusionRemoval = (subgroupId: string) => {
    const parentGroup = allGroups.find((g) => g.subgroups?.some((s) => s.id === subgroupId));
    if (!parentGroup) return;

    const parentPresent = groupAccessList.some((a) => a.group.id === parentGroup.id) || newGroups.some((g) => g.id === parentGroup.id);
    if (!parentPresent) return;

    const parent = getParentCurrentAccessAndAllow(parentGroup.id);
    if (parent.accessTitle === null) return;

    let accessToApply = parent.accessTitle!;
    let allowToApply = parent.allow!;
    let markExcluded = true;

    if (accessToApply === ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS) {
      const orgEff = getEffectiveOrganizationAccess();
      if (orgEff.exists) {
        accessToApply = orgEff.access!;
        allowToApply = orgEff.allow!;
      } else {
        accessToApply = ACCESS_TYPE_ENUM.WITHOUT_ACCESS;
        allowToApply = false;
        markExcluded = false;
      }
    }

    const mapCopy = lodash.cloneDeep(accessMapJson);
    const pIdx = mapCopy.findIndex((g) => g.id === parentGroup.id);
    if (pIdx >= 0) {
      const sIdx = mapCopy[pIdx].subGroups.findIndex((s) => s.id === subgroupId);
      if (sIdx >= 0) {
        mapCopy[pIdx].subGroups[sIdx] = { id: subgroupId, access: accessToApply };
      } else {
        mapCopy[pIdx].subGroups.push({ id: subgroupId, access: accessToApply });
      }
      setAccessMapJson(mapCopy);
    }

    const existingSub = subGroupAccessList.find((a) => a.group.id === subgroupId);
    if (existingSub) {
      enqueue({
        kind: ActionKind.PATCH_ACCESS,
        when: Date.now(),
        accessId: existingSub.id,
        access: accessToApply,
        ...(typeof markExcluded === 'boolean' ? { excluded: markExcluded } : {}),
      });
      enqueueDownload(existingSub.id, allowToApply);
      setDownloadPermissions((prev) => ({ ...prev, [existingSub.id]: { allowDownload: allowToApply } }));
    } else {
      enqueue({
        kind: ActionKind.CREATE_ACCESS,
        when: Date.now(),
        body: {
          targetType: 'online_composer',
          targetId: thisComposer!.id,
          group: subgroupId,
          allowDownloads: allowToApply,
          type: 'group',
          access: accessToApply,
          excluded: markExcluded,
        },
      });
      setNewGroupAccess((prev) => ({
        ...(prev ?? {}),
        [subgroupId]: {
          targetType: 'online_composer',
          targetId: thisComposer!.id,
          group: subgroupId,
          allowDownloads: allowToApply,
          type: 'group',
          access: accessToApply,
          excluded: markExcluded,
        },
      }));
    }
  };

  // ====== Message/notify ======
  const [notify, setNotify] = useState(false);
  const [messageTextForSharedContent, setMessageText] = useState('');
  const switchNotify = () => {
    setNotify(!notify);
    setMessageText('');
  };
  const onMessageTextInput = (e: any) => setMessageText(e.target.value);

  const canNotifyNewUsers = plannedOps.some(
    (action) => action.kind === ActionKind.CREATE_ACCESS || action.kind === ActionKind.PATCH_ACCESS,
  );

  useEffect(() => {
    if (!canNotifyNewUsers && notify) {
      setNotify(false);
    }
  }, [canNotifyNewUsers, notify]);

  // ====== New excluded ======
  const [newExcludedUsers, setNewExcludedUsers] = useState<(USER_NEW | GROUP)[]>([]);
  const [newExcludedUsersAccess, setNewExcludedUsersAccess] = useState<NewAccessType>();

  const filterEntries = (obj: any) => {
    const userIdsToRemove = new Set();
    const groupIdsToRemove = new Set();

    for (const elem of Object.values(obj)) {
      const entry = elem as any;
      if (entry.type === 'group') {
        if (Array.isArray(entry.members)) entry.members.forEach((id: any) => userIdsToRemove.add(String(id)));
        if (Array.isArray(entry.subgroups)) entry.subgroups.forEach((id: any) => groupIdsToRemove.add(String(id)));
      }
    }

    const result = {} as any;
    for (const [key, elem] of Object.entries(obj)) {
      const entry = elem as any;
      if (entry.type === 'user' && userIdsToRemove.has(String(entry.user))) continue;
      if (entry.type === 'group' && groupIdsToRemove.has(String(entry.group))) continue;
      result[key] = entry;
    }

    return result;
  };

  // ====== Submit ======
  const createUrl = (id?: string) => {
    let result = `${PATHS.COMPOSER_PAGE.path}?feedId=${id}&fileside=true&clip=0&pageType=MY_COMPOSER&sharedComposer=true`;
    return result;
  };

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    const redirectUrlToSend = createUrl(thisComposer?.id);

    e.preventDefault();
    setLoading(true);
    try {
      await drainQueue(redirectUrlToSend);

      if (idsToRenotify && (idsToRenotify.userIds.length || idsToRenotify?.groupIds.length)) {
        await postRenotify(idsToRenotify, redirectUrlToSend, messageTextForSharedContent);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setTimeout(() => {
        // setFetchTrigger(Date.now());
        setNotify(false);
        closeModal();
        if (onUpdate) onUpdate({});
        setIdsToRenotify(null);
        setMessageText('');
        setLoading(false);
        setPendingDeleteIds([]);
        actionQ.current = [];
        setPlannedOps([]);
        setHasPending(false);
      }, 2000);
    }
  };

  // ====== Close / reset ======
  const closeModal = () => {
    dispatch(removeSelectedFolder());
    dispatch(removeSelectedComposer());
    dispatch(switchShareModal(false));
    dispatch(switchShareModalComposer(false));
    setSearchedUsers([]);
    setSearchText('');
    setSearchedGroups([]);
    setSearchGroupText('');
    setSearchedExclusions([]);
    setSearchExclusionsText('');
    setUsersAccess(undefined);
    setGroupAccess(undefined);
    setNewExcludedUsersAccess(undefined);
    setNewUsers([]);
    setNewGroups([]);
    setShareWithOrganization(false);
    setNewExcludedUsers([]);
    setNewOrganizationAccess(undefined);
    setNewUsersAccess(undefined);
    setNewGroupAccess(undefined);
    setUserAccessList([]);
    setGroupAccessList([]);
    setExcludedUsersAccessList([]);
    setIdsToRenotify(null);
    setRenotifyAll(false);
    setAccessMapJson([]);
    setMessageText('');
    setPendingDeleteIds([]);
    actionQ.current = [];
    setPlannedOps([]);
    setHasPending(false);
  };

  // ====== UI add/remove handlers ======
  const onNewUserClick = (user: USER_NEW, index: number) => {
    setNewUsers([user, ...newUsers]);
    searchedUsers.splice(index, 1);
    setSearchedUsers([...searchedUsers]);
    const allowDownloads = getDefaultShareAllowDownloads(user.role?.title || user.user.role?.title);

    enqueue({
      kind: ActionKind.CREATE_ACCESS,
      when: Date.now(),
      body: {
        targetType: 'online_composer',
        targetId: thisComposer!.id,
        user: user.user.id,
        allowDownloads,
        type: 'user',
        access: ACCESS_TYPE_KEYS[ACCESS_TYPE.COMMENT_AND_CREATE],
      },
    });

    const obj = {
      ...newUsersAccess,
      [user.user.id]: {
        targetType: 'online_composer',
        targetId: thisComposer?.id,
        user: user.user.id,
        allowDownloads,
        type: 'user',
        access: ACCESS_TYPE_KEYS[ACCESS_TYPE.COMMENT_AND_CREATE],
      },
    };
    setNewUsersAccess(obj);
  };

  const onNewExcludedUserClick = (data: USER_NEW | GROUP, index: number) => {
    setNewExcludedUsers([data, ...newExcludedUsers]);
    searchedExclusions.splice(index, 1);
    setSearchedExclusions([...searchedExclusions]);

    let newEntry: any;
    if ('user_name' in data) {
      const u = data as USER_NEW;
      newEntry = {
        targetType: 'online_composer',
        targetId: thisComposer!.id,
        allowDownloads: false,
        user: u.user.id,
        type: 'user',
        access: ACCESS_TYPE_KEYS[ACCESS_TYPE.NO_ACCESS],
        excluded: true,
      };
    } else {
      const g = data as GROUP;
      newEntry = {
        targetType: 'online_composer',
        targetId: thisComposer!.id,
        group: g.id,
        allowDownloads: false,
        members: g.members ? g.members.map((m) => m.id) : [],
        subgroups: g.subgroups ? g.subgroups.map((s) => s.id) : [],
        type: 'group',
        access: ACCESS_TYPE_KEYS[ACCESS_TYPE.NO_ACCESS],
        excluded: true,
      };
    }

    const key = newEntry.user ?? newEntry.group;
    setNewExcludedUsersAccess((prev) => ({ ...(prev ?? {}), [key]: newEntry }));

    enqueue({ kind: ActionKind.CREATE_ACCESS, when: Date.now(), body: { ...newEntry } });
  };

  const onNewGroupClick = (group: GROUP, index: number) => {
    setNewGroups([group, ...newGroups]);
    searchedGroups.splice(index, 1);
    setSearchedGroups([...searchedGroups]);

    const baseAccess = ACCESS_TYPE_ENUM.COMMENT_AND_CREATE;

    enqueue({
      kind: ActionKind.CREATE_ACCESS,
      when: Date.now(),
      body: {
        targetType: shareFolder ? 'folder' : 'online_composer',
        targetId: shareFolder?.id ?? thisComposer!.id,
        group: group.id,
        allowDownloads: getDefaultShareAllowDownloads(),
        type: 'group',
        access: baseAccess,
      },
    });

    const accessMapJsonCopied = lodash.cloneDeep(accessMapJson);
    if (group.subgroups.length) {
      group.subgroups.forEach((sub) => {
        const excludedSubgroup =
          excludedUsersAccessList
            .filter((elem) => elem.type === 'group')
            .map((groupAcc) => groupAcc.group!.id)
            .includes(sub.id) || (newExcludedUsers.filter((elem) => 'title' in elem) as GROUP[]).map((g) => g.id).includes(sub.id);

        enqueue({
          kind: ActionKind.CREATE_ACCESS,
          when: Date.now(),
          body: {
            targetType: shareFolder ? 'folder' : 'online_composer',
            targetId: shareFolder?.id ?? thisComposer!.id,
            group: sub.id,
            allowDownloads: excludedSubgroup ? false : getDefaultShareAllowDownloads(),
            type: 'group',
            access: excludedSubgroup ? ACCESS_TYPE_ENUM.WITHOUT_ACCESS : baseAccess,
          },
        });
      });
      accessMapJsonCopied.push({
        id: group.id,
        access: baseAccess,
        subGroups: group.subgroups.map((s) => {
          const excludedSubgroup =
            excludedUsersAccessList
              .filter((elem) => elem.type === 'group')
              .map((groupAcc) => groupAcc.group!.id)
              .includes(s.id) || (newExcludedUsers.filter((elem) => 'title' in elem) as GROUP[]).map((g) => g.id).includes(s.id);

          return {
            id: s.id,
            access: excludedSubgroup ? ACCESS_TYPE_ENUM.WITHOUT_ACCESS : baseAccess,
          };
        }),
      });
    } else {
      accessMapJsonCopied.push({
        id: group.id,
        access: baseAccess,
        subGroups: [],
      });
    }

    setAccessMapJson(accessMapJsonCopied);
  };

  const handleDeleteAccess = (accessId: string, accessType?: 'user' | 'group' | 'subgroup' | 'organization', groupId?: string) => {
    try {
      if (accessType === 'group') {
        const subgroupIds = groupAccessList.find((obj) => obj.id == accessId)?.group?.subgroups.map((sub) => sub.id) || [];
        const subgroupAccessIds = subGroupAccessList.filter((subAcc) => subgroupIds.includes(subAcc.group.id)).map((subAcc) => subAcc.id);
        subgroupAccessIds.forEach((sid) => enqueue({ kind: ActionKind.DELETE_ACCESS, when: Date.now(), accessId: sid }));
        enqueue({ kind: ActionKind.DELETE_ACCESS, when: Date.now(), accessId });

        setGroupAccessList((prev) => prev.filter((a) => a.id !== accessId));
        setSubGroupAccessList((prev) => prev.filter((a) => !subgroupIds.includes(a.group.id)));
        setExcludedUsersAccessList((prev) => prev.filter((a) => a.id !== accessId));
      } else if (accessType === 'subgroup') {
        enqueue({ kind: ActionKind.DELETE_ACCESS, when: Date.now(), accessId });

        setUserAccessList((prev) => prev.filter((a) => a.id !== accessId));
        setExcludedUsersAccessList((prev) => prev.filter((a) => a.id !== accessId));
        setSubGroupAccessList((prev) => prev.filter((a) => a.id !== accessId));

        if (groupId) {
          const parentGroup = allGroups.find((g) => g.subgroups?.some((s) => s.id === groupId));
          const parentPresent =
            !!parentGroup && (groupAccessList.some((a) => a.group.id === parentGroup.id) || newGroups.some((g) => g.id === parentGroup.id));
          const subgroupPresent = subGroupAccessList.some((a) => a.group.id === groupId) || !!newGroupAccess?.[groupId];

          if (!parentPresent && !subgroupPresent) {
            return;
          }
        }

        if (groupId) {
          const parent = accessMapJson.find((g) => g.subGroups.some((s) => s.id === groupId));
          const parentId = parent?.id;
          const parentAccessTitle = normalizeAccessTitle(parent?.access);

          let desiredAccess: ACCESS_TYPE_ENUM;
          let desiredExclusion = true;
          let desiredAllow: boolean;

          if (parentAccessTitle && parentAccessTitle !== ACCESS_TYPE_ENUM.SUBGROUP_SPECIFIC_ACCESS) {
            // звичайне успадкування від батьківської групи
            desiredAccess = parentAccessTitle;
            const parentAcc = parentId ? groupAccessList.find((ga) => ga.group.id === parentId) : undefined;
            const parentAllow =
              (parentAcc && (downloadPermissions[parentAcc.id]?.allowDownload ?? parentAcc.allow_downloads)) ??
              getDefaultShareAllowDownloads();
            desiredAllow = !!parentAllow;
          } else {
            // 🟣 parent = SUBGROUP_SPECIFIC_ACCESS → спробувати успадкувати від організації; інакше дефолт CC + no downloads
            const orgEff = getEffectiveOrganizationAccess();
            if (orgEff.exists) {
              desiredAccess = orgEff.access!;
              desiredAllow = orgEff.allow!;
            } else {
              desiredAccess = ACCESS_TYPE_ENUM.NO_ACCESS;
              desiredAllow = false;
              desiredExclusion = false;
            }
          }

          const existingSubAccess = subGroupAccessList.find((sa) => sa.group.id === groupId);

          if (existingSubAccess) {
            enqueue({
              kind: ActionKind.PATCH_ACCESS,
              when: Date.now(),
              accessId: existingSubAccess.id,
              access: desiredAccess,
              doNotNotify: false,
              excluded: desiredExclusion,
            });

            setAccessMapJson((prev) =>
              prev.map((g) =>
                g.id !== (parentId || g.id)
                  ? g
                  : { ...g, subGroups: g.subGroups.map((s) => (s.id === groupId ? { ...s, access: desiredAccess } : s)) },
              ),
            );

            setDownloadPermissions((prev) => ({
              ...prev,
              [existingSubAccess.id]: { allowDownload: desiredAllow },
            }));
            enqueueDownload(existingSubAccess.id, desiredAllow);
          } else {
            // створюємо доступ для сабгрупи з розрахованими значеннями
            const draft: NewAccessType = {
              ...(newGroupAccess || {}),
              [groupId]: {
                targetType: 'online_composer',
                targetId: thisComposer!.id,
                group: groupId,
                allowDownloads: desiredAllow,
                type: 'group',
                access: desiredAccess,
                excluded: desiredExclusion,
                doNotNotify: false,
              },
            };

            setNewGroupAccess(draft);

            // прибрати можливі дублікати CREATE для цієї сабгрупи
            actionQ.current = actionQ.current.filter(
              (a) =>
                !(
                  a.kind === ActionKind.CREATE_ACCESS &&
                  (a as CreateAccessAction).body.type === 'group' &&
                  (a as CreateAccessAction).body.group === groupId
                ),
            );

            enqueue({
              kind: ActionKind.CREATE_ACCESS,
              when: Date.now(),
              body: draft[groupId] as any,
            });

            setAccessMapJson((prev) =>
              prev.map((g) =>
                g.id !== (parentId || g.id)
                  ? g
                  : { ...g, subGroups: g.subGroups.map((s) => (s.id === groupId ? { ...s, access: desiredAccess } : s)) },
              ),
            );
          }
        }
      } else {
        enqueue({ kind: ActionKind.DELETE_ACCESS, when: Date.now(), accessId });
        setUserAccessList((prev) => prev.filter((a) => a.id !== accessId));
        setExcludedUsersAccessList((prev) => prev.filter((a) => a.id !== accessId));
      }

      queueDeletion(accessId);
      // setFetchTrigger && setFetchTrigger(Date.now());
    } catch (error: any) {
      notification.showMessage(error?.response?.data?.message);
    }
  };

  const handleDeleteNewUser = (userId: string) => {
    setNewUsers(newUsers.filter((user) => user.user.id !== userId));
    cancelCreateFor((a) => a.body.type === 'user' && a.body.user === userId);
    if (newUsersAccess) {
      delete newUsersAccess[userId];
      setNewUsersAccess(Object.keys(newUsersAccess).length !== 0 ? newUsersAccess : undefined);
    }
  };

  useEffect(() => {
    if (!searchedExclusions.length) return;

    const raf = requestAnimationFrame(() => {
      const wrapper = contentWrapperRef.current;
      const container = searchExcludedUsersResultBarRef.current as HTMLDivElement | null;

      if (!wrapper || !container) return;

      const list = container.querySelector(`.${css.searchList}`) as HTMLElement | null;
      const firstItem = (list?.querySelector(`.${css.user}`) as HTMLElement | null) || (list?.firstElementChild as HTMLElement | null);

      if (!firstItem) return;

      firstItem.scrollIntoView({ block: 'nearest', behavior: 'smooth' });

      const wRect = wrapper.getBoundingClientRect();
      const fRect = firstItem.getBoundingClientRect();
      if (fRect.bottom > wRect.bottom) {
        wrapper.scrollBy({ top: fRect.bottom - wRect.bottom + 8, behavior: 'smooth' });
      }
    });

    return () => cancelAnimationFrame(raf);
  }, [searchedExclusions.length]);

  const handleDeleteNewGroup = (groupId: string) => {
    setNewGroups(newGroups.filter((group) => group.id !== groupId));

    const subs = (newGroups.find((g) => g.id === groupId)?.subgroups ?? []).map((s) => s.id);
    actionQ.current = actionQ.current.filter((a) => {
      if (a.kind !== ActionKind.CREATE_ACCESS) return true;
      const c = a as CreateAccessAction;
      return !(c.body.type === 'group' && (c.body.group === groupId || subs.includes(c.body.group!)));
    });
    syncPlanned();

    if (newGroupAccess) {
      delete newGroupAccess[groupId];
      setNewGroupAccess(Object.keys(newGroupAccess).length ? newGroupAccess : undefined);
    }
  };

  const handleDeleteOrganization = () => {
    const orgAccess = thisComposer?.access.find((access) => access.type === 'organization');
    if (orgAccess) {
      handleDeleteAccess(orgAccess.id, 'organization');
    } else {
      // якщо ще не створено — прибираємо CREATE для організації
      const orgId = String(thisComposer!.organization_id);
      actionQ.current = actionQ.current.filter((a) => {
        if (a.kind !== ActionKind.CREATE_ACCESS) return true;
        const c = a as CreateAccessAction;
        return !(c.body.type === 'organization' && c.body.organization === orgId);
      });
      syncPlanned();
    }

    setNewExcludedUsers([]);
    setNewOrganizationAccess(undefined);
    setShareWithOrganization(false);
  };

  const handleDeleteNewExcludedUser = (entityId: string) => {
    const removedEntity = newExcludedUsers.find((u) => u.id === entityId) as GROUP | USER_NEW | undefined;

    setNewExcludedUsers(newExcludedUsers.filter((u) => u.id !== entityId));

    actionQ.current = actionQ.current.filter((a) => {
      if (a.kind !== ActionKind.CREATE_ACCESS) return true;
      const c = a as CreateAccessAction;
      return !((c.body.type === 'user' && c.body.user === entityId) || (c.body.type === 'group' && c.body.group === entityId));
    });
    syncPlanned();

    if (newExcludedUsersAccess) {
      delete newExcludedUsersAccess[entityId];
      setNewExcludedUsersAccess(Object.keys(newExcludedUsersAccess).length ? newExcludedUsersAccess : undefined);
    }

    const isSubgroup =
      (removedEntity as GROUP | undefined)?.type === GROUP_TYPE.SUBGROUP ||
      allGroups.some((g) => g.subgroups?.some((s) => s.id === entityId));

    if (isSubgroup) {
      // 🔒 додатковий гард, щоб не відновлювати ізольовані сабгрупи
      const parentGroup = allGroups.find((g) => g.subgroups?.some((s) => s.id === entityId));
      const parentPresent =
        !!parentGroup && (groupAccessList.some((a) => a.group.id === parentGroup.id) || newGroups.some((g) => g.id === parentGroup.id));
      const subgroupPresent = subGroupAccessList.some((a) => a.group.id === entityId) || !!newGroupAccess?.[entityId];

      if (parentPresent || subgroupPresent) {
        restoreSubgroupAfterExclusionRemoval(entityId);
      }
    }
  };

  // ====== Hotkeys & Outside click ======
  useHotkeys('Enter', () => {
    if ((showShareModal || showShareModalComposer) && !loading) submitButtonRef?.current?.click();
  });

  const onSearchResultsDismiss = () => {
    setSearchedUsers([]);
    setSearchText('');
  };
  const onSearchExcludedUsersResultsDismiss = () => {
    setSearchedExclusions([]);
    setSearchExclusionsText('');
  };
  const onGroupSearchResultsDismiss = () => {
    setSearchedGroups([]);
    setSearchGroupText('');
  };

  useOnClickOutside(searchResultBarRef, onSearchResultsDismiss);
  useOnClickOutside(searchExcludedUsersResultBarRef, onSearchExcludedUsersResultsDismiss);
  useOnClickOutside(searchGroupResultBarRef, onGroupSearchResultsDismiss);

  // ====== Render ======
  return (
    <Modal open={showShareModal || showShareModalComposer} onClose={closeModal} loading={loading} mobileFullScreen>
      <form className={css.modalBody} onSubmit={onSubmit}>
        <div className={css.modalTitle}>Share {`“${thisComposer?.title}”`} composer</div>
        <div className={css.contentWrapper} ref={contentWrapperRef}>
          <div className={css.organizationAccessWrapper}>
            <div className={css.notifyCheckBox}>
              <div className={css.checkboxWrapper30}>
                <span className={css.checkbox}>
                  <input type="checkbox" onChange={switchShareWithEveryone} checked={shareWithOrganization} />
                  <svg>
                    <use xlinkHref="#checkbox-30" className={css.checkbox}></use>
                  </svg>
                </span>
                <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
                  <symbol id="checkbox-30" viewBox="0 0 22 22">
                    <path
                      fill="none"
                      stroke="currentColor"
                      d="M5.5,11.3L9,14.8L20.2,3.3l0,0c-0.5-1-1.5-1.8-2.7-1.8h-13c-1.7,0-3,1.3-3,3v13c0,1.7,1.3,3,3,3h13 c1.7,0,3-1.3,3-3v-13c0-0.4-0.1-0.8-0.3-1.2"
                    />
                  </symbol>
                </svg>
                Share to All Users?
              </div>
            </div>
            {shareWithOrganization && (
              <div className={css.organizationAccessListWrapper}>
                <AllUsersList
                  css={css}
                  orgDownloadPermission={orgDownloadPermission}
                  onOrgDownloadPermissionChange={onOrgDownloadPermissionChange}
                  orgAccess={thisComposer?.access.find((access) => access.type === 'organization')}
                  onNewOrganizationAccessChange={onNewOrganizationAccessChange}
                  onOrganizationDelete={handleDeleteOrganization}
                />
              </div>
            )}
          </div>

          <div className={css.sectionTitle}>Groups & subgroups with access</div>
          <SearchInput className={css.search} onChange={onGroupSearch} placeHolder="Search groups" />
          <div ref={searchGroupResultBarRef} className={css.searchResultContainer}>
            {searchedGroups.length > 0 && (
              <div className={css.searchList}>
                {searchedGroups.map((group: GROUP, i: number) =>
                  (newExcludedUsers.filter((elem) => 'title' in elem) as GROUP[])
                    .map((group) => [group.id, group.subgroups.map((sub) => sub.id)])
                    .flat(Infinity)
                    .includes(group.id) ||
                  excludedUsersAccessList
                    .filter((elem) => elem.group)
                    .map((g) => +g.group.id)
                    .includes(+group.id) ? (
                    <div className={cs(css.user, css.excludedUsers)} key={group.id}>
                      <div className={css.username}>{group?.title}</div>
                      <div className={css.groupPeople}>{group?.analysts.length + group.viewers.length} people</div>
                      <div className={css.groupLabel}>Group</div>
                    </div>
                  ) : (
                    <div onClick={() => onNewGroupClick(group, i)} className={css.user} key={group.id}>
                      <div className={css.username}>{group?.title}</div>
                      <div className={css.groupPeople}>{group?.analysts.length + group.viewers.length} people</div>
                      <div className={css.groupLabel}>Group</div>
                    </div>
                  ),
                )}
              </div>
            )}
            {searchGroupText.trim().length > 0 && isGroupSearchEmpty && !isGroupSearchLoading && (
              <div className={css.noResults}>No Groups Found</div>
            )}
          </div>
          <ShareComposerModalGroupsList
            newExcludedGroups={newExcludedUsers.filter((elem) => 'title' in elem) as GROUP[]}
            excludedUsersAccessList={excludedUsersAccessList.filter((elem) => elem.type === 'group')}
            onNewGroupDownloadPermissionChange={onNewGroupDownloadPermissionChange}
            onDownloadPermissionChange={onDownloadPermissionChange}
            downloadPermissions={downloadPermissions}
            newGroupAccess={newGroupAccess}
            accessMapJson={accessMapJson}
            groupList={groupAccessList}
            newGroups={newGroups}
            onGroupAccessChange={onGroupAccessChange}
            onNewGroupAccessChange={onNewGroupAccessChange}
            subGroupList={subGroupAccessList}
            onAccessDelete={handleDeleteAccess}
            onNewGroupDelete={handleDeleteNewGroup}
            addEntityToRenotify={addEntityToRenotify}
            idsToRenotify={idsToRenotify}
          />

          <div className={css.sectionTitle}>Additional Access</div>
          <div className={css.searchWrapper}>
            <SearchInput className={css.search} onChange={onUserSearch} />
            {(userAccessList.length > 0 || groupAccessList.length > 0) && (
              <Tooltip title={renotifyAll ? 'Re-notify all on submit' : 'Re-notify all is off'}>
                <div
                  className={css.renotifyAll}
                  onClick={switchNotifyAll}
                >
                  Re-notify all?
                  <img src={renotifyAll ? BellIconFilled : BellIcon} alt="renotify all" className={css.bellIcon} />
                </div>
              </Tooltip>
            )}
          </div>
          <div ref={searchResultBarRef} className={css.searchResultContainer}>
            {searchedUsers.length > 0 && (
              <div className={css.searchList}>
                {searchedUsers.map((obj, i: number) =>
                  (newExcludedUsers.filter((elem) => 'user_name' in elem) as USER_NEW[])
                    .map((user) => user.user.id)
                    .includes(obj.user.id) ||
                  (newExcludedUsers.filter((elem) => 'title' in elem) as GROUP[])
                    .map((group) => group.members?.map((elem) => elem.id))
                    .flat()
                    .includes(obj.user.id) ||
                  excludedUsersAccessList
                    .filter((elem) => elem.user)
                    .map((user) => user.user.id)
                    .includes(obj.user.id) ||
                  excludedUsersAccessList
                    .filter((elem) => elem.group)
                    .map((group) => [...(group.group.analysts || []), ...(group.group.viewers || [])].map((u) => u.id))
                    .flat(Infinity)
                    .includes(obj.user.id) ? (
                    <div className={cs(css.user, css.excludedUsers)} key={obj.user.id}>
                      <div>
                        <div className={css.username}>{obj.user?.username}</div>
                        {canViewEmails && (<div className={css.email}>{obj.user.email}</div>)}
                      </div>
                      <div>
                        <RolePlate className={css.rolePlate} userRole={obj.role.title} />
                      </div>
                    </div>
                  ) : (
                    <div onClick={() => onNewUserClick(obj, i)} className={css.user} key={obj.user.id}>
                      <div>
                        <div className={css.username}>{obj.user?.username}</div>
                        {canViewEmails && (<div className={css.email}>{obj.user.email}</div>)}
                      </div>
                      <div>
                        <RolePlate className={css.rolePlate} userRole={obj.role.title} />
                      </div>
                    </div>
                  ),
                )}
              </div>
            )}
            {searchText.trim().length > 0 && isUserSearchEmpty && !isUserSearchLoading && (
              <div className={css.noResults}>No Users Found</div>
            )}
          </div>
          <ShareComposerModalUserList
            downloadPermissions={downloadPermissions}
            onDownloadPermissionChange={onDownloadPermissionChange}
            onNewUserDownloadPermissionChange={onNewUserDownloadPermissionChange}
            newUsersAccess={newUsersAccess}
            newExcludedUsers={newExcludedUsers}
            excludedUsersAccessList={excludedUsersAccessList.filter((elem) => elem.type === 'user')}
            newUsers={newUsers}
            userList={userAccessList}
            onNewUserAccessChange={onNewUserAccessChange}
            onUserAccessChange={onUserAccessChange}
            onAccessDelete={handleDeleteAccess}
            onNewUserDelete={handleDeleteNewUser}
            addEntityToRenotify={addEntityToRenotify}
            idsToRenotify={idsToRenotify}
            owner={thisComposer?.created_by}
          />

          <div className={css.sectionTitle}>Exclude Access</div>
          <div className={css.searchWrapper}>
            <SearchInput className={css.search} onChange={onExclusionsSearch} />
          </div>
          <div ref={searchExcludedUsersResultBarRef} className={css.searchResultContainer}>
            {searchedExclusions.length > 0 && (
              <div className={css.searchList}>
                {searchedExclusions.map((obj: USER_NEW | GROUP, i: number) => {
                  if ('user_name' in obj) {
                    if (obj.user.id === thisComposer?.created_by.id) return;
                    if (
                      (newExcludedUsers.filter((elem) => 'user_name' in elem) as USER_NEW[]).map((u) => u.user.id).includes(obj.user.id) ||
                      (newExcludedUsers.filter((elem) => 'title' in elem) as GROUP[])
                        .map((g) => g.members?.map((m) => m.id))
                        .flat()
                        .includes(obj.user.id) ||
                      excludedUsersAccessList
                        .filter((e) => e.user)
                        .map((u) => u.user.id)
                        .includes(obj.user.id) ||
                      excludedUsersAccessList
                        .filter((e) => e.group)
                        .map((g) => [...(g.group.analysts || []), ...(g.group.viewers || [])].map((u) => u.id))
                        .flat(Infinity)
                        .includes(obj.user.id)
                    ) {
                      return (
                        <div className={cs(css.user, css.excludedUsers)} key={obj.user.id}>
                          <div>
                            <div className={css.username}>{obj.user?.username}</div>
                            {canViewEmails && (<div className={css.email}>{obj.user.email}</div>)}
                          </div>
                          <div>
                            <RolePlate className={css.rolePlate} userRole={obj.role.title} />
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div onClick={() => onNewExcludedUserClick(obj, i)} className={css.user} key={obj.user.id}>
                          <div>
                            <div className={css.username}>{obj.user?.username}</div>
                            {canViewEmails && (<div className={css.email}>{obj.user.email}</div>)}
                          </div>
                          <div>
                            <RolePlate className={css.rolePlate} userRole={obj.role.title} />
                          </div>
                        </div>
                      );
                    }
                  } else {
                    if (
                      (newExcludedUsers.filter((elem) => 'title' in elem) as GROUP[])
                        .map((g) => g.subgroups?.map((s) => s.id))
                        .flat()
                        .includes(obj.id) ||
                      (excludedUsersAccessList.filter((e) => e.type === 'group').map((ex) => ex.group) as GROUP[])
                        .map((g) => g.subgroups?.map((s) => s.id))
                        .flat()
                        .includes(obj.id)
                    ) {
                      return (
                        <div className={cs(css.user, css.excludedUsers)} key={obj.id}>
                          <div>
                            <div className={css.username}>{obj?.title}</div>
                            <div className={css.parentGroup}>{obj.parentGroup?.title}</div>
                          </div>

                          <div className={css.groupInfo}>
                            <div className={css.groupPeople}>{obj?.numberOfMembers} people</div>
                            {obj.type === GROUP_TYPE.GROUP ? (
                              <div className={css.groupLabel}>Group</div>
                            ) : (
                              <div className={css.subgroupLabel}>Subgroup</div>
                            )}
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div onClick={() => onNewExcludedUserClick(obj, i)} className={css.user} key={obj.id}>
                          <div>
                            <div className={css.username}>{obj?.title}</div>
                            <div className={css.parentGroup}>{obj.parentGroup?.title}</div>
                          </div>

                          <div className={css.groupInfo}>
                            <div className={css.groupPeople}>{obj?.numberOfMembers} people</div>
                            {obj.type === GROUP_TYPE.GROUP ? (
                              <div className={css.groupLabel}>Group</div>
                            ) : (
                              <div className={css.subgroupLabel}>Subgroup</div>
                            )}
                          </div>
                        </div>
                      );
                    }
                  }
                })}
              </div>
            )}
            {searchExclusionsText.trim().length > 0 && isExclusionsSearchEmpty && !isExclusionsSearchLoading && (
              <div className={css.noResultsExclude}>No Results Found</div>
            )}
          </div>

          <ShareModalExcludedUserList
            css={css}
            newUsers={newExcludedUsers}
            accessList={excludedUsersAccessList}
            onAccessDelete={handleDeleteAccess}
            onNewUserDelete={handleDeleteNewExcludedUser}
          />
        </div>

        <div className={css.notifyCheckBox} style={!canNotifyNewUsers ? { opacity: 0.5 } : undefined}>
          <div className={css.checkboxWrapper30}>
            <span className={css.checkbox}>
              <input type="checkbox" onChange={switchNotify} checked={notify} disabled={!canNotifyNewUsers} />
              <svg>
                <use xlinkHref="#checkbox-30" className={css.checkbox}></use>
              </svg>
            </span>
            <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
              <symbol id="checkbox-30" viewBox="0 0 22 22">
                <path
                  fill="none"
                  stroke="currentColor"
                  d="M5.5,11.3L9,14.8L20.2,3.3l0,0c-0.5-1-1.5-1.8-2.7-1.8h-13c-1.7,0-3,1.3-3,3v13c0,1.7,1.3,3,3,3h13 c1.7,0,3-1.3,3-3v-13c0-0.4-0.1-0.8-0.3-1.2"
                />
              </symbol>
            </svg>
            Notify New Users?
          </div>
        </div>

        {(notify || !!idsToRenotify?.groupIds?.length || !!idsToRenotify?.userIds?.length) && (
          <div className={css.messageText}>
            <textarea
              className={css.messageTextField}
              placeholder="Leave a message for them about content"
              style={{ resize: 'vertical', overflow: 'hidden' }}
              id="messageText"
              cols={33}
              onChange={onMessageTextInput}
              value={messageTextForSharedContent}
            />
          </div>
        )}
        <div className={css.actionBtns}>
          <OutlinedButton kind="default" type={'button'} onClick={closeModal} disabled={loading}>
            <div>Cancel</div>
          </OutlinedButton>
          <ContainedButton
            type={'submit'}
            disabled={!(hasPending || !!idsToRenotify?.groupIds?.length || !!idsToRenotify?.userIds?.length) || loading}
          >
            <div ref={submitButtonRef}>Confirm</div>
          </ContainedButton>
        </div>
      </form>
    </Modal>
  );
};

export default ShareComposerModal;
